const PLAN = {
  MONTHLY_BASIC: 'monthly_basic',
  YEARLY_BASIC: 'yearly_basic',
  MONTHLY_PRO: 'monthly_pro',
  YEARLY_PRO: 'yearly_pro',
  BASIC_TRIAL: 'basic_trial',
  PRO_TRIAL: 'pro_trial',
}
export default PLAN
